<section id="warning-modal">
  <div>
    <h2 i18n="@@hotelWarningTitle">
      Warning<a
        class="close"
        (click)="onCancel()"
        role="button"
        aria-label="Close Warning Hotel Modal Box"
        >&times;</a
      >
    </h2>
  </div>
  <p id="warning-body" i18n="@@hotelWarningMessage">
    <i class="ico-exclaim-1 ico-exclaim-1--mild ico-float-left"></i><b>PLEASE NOTE:</b> If one of
    these rooms fails to book you will be liable for any confirmed rooms that cannot be cancelled
    without charge.
  </p>
  <div id="confirm-button"><button (click)="onAccept()" i18n="@@hotelWarningOK">OK</button></div>
</section>
